var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Icons'),_c('router-view'),_c('a',{staticClass:"credits",attrs:{"href":"https://mwd.digital","target":"_blank"}},[_c('svg',{attrs:{"viewBox":"0 0 50 50"}},[_c('use',{attrs:{"xlink:href":"#logo--mwd","width":"100%","height":"100%"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }